import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDesigner } from '../../../hooks/useDesigner';
import {
  useFollowDesigner,
  useIsDesignerFollowed,
  useUnfollowDesigner
} from '../../../hooks/useDesignerPreferences';
import { AccountDesignerPreferencesVertical } from '../../../hooks/useDesigners';

export const useSingleDesignerChip = () => {
  const { designerSlug, vertical } = useParams<{
    vertical: AccountDesignerPreferencesVertical;
    designerSlug: string;
  }>();

  const { designer, loading: designerLoading } = useDesigner(designerSlug);

  const { followDesigner } = useFollowDesigner(vertical);
  const { unfollowDesigner } = useUnfollowDesigner(vertical);

  const { isFollowed, loading: followingLoading } = useIsDesignerFollowed(vertical, designer?.id);

  const handleFollow = useCallback(
    (id: string, name: string | null) => followDesigner(id, name),
    [followDesigner]
  );

  const handleUnfollow = useCallback(
    (id: string, name: string | null) => unfollowDesigner(id, name),
    [unfollowDesigner]
  );

  return {
    designer,
    handleFollow,
    handleUnfollow,
    isFollowed,
    loading: designerLoading || followingLoading
  };
};
